<template>
	<v-layout justify-center @drop.prevent @dragover.prevent>
		<v-flex sm12 md10 lg8>
			<uploader
				:title="schoolName"
				:subtitle="subtitle"
				:album-id="albumId"
				:complete-message="i18n('uploader.guest.completeMessage')"
				:embedded-tags="tags"
				:tag-label="i18n('uploader.guest.tags')"
				class="uploader-page"
				photoCategory="candid_category"
				:accepted-file-extensions="acceptedFileExtensions"
				:photo-converters="photoConverters"
				:allow-folder-uploads="false"
				:instagram-use-popup="false"
				:choose-file-header-component="chooseFileHeaderComponent"
				:extra-step-props="extraStepProps" />
		</v-flex>
	</v-layout>
</template>

<script>
import Uploader from '../../PlicCanvas/vue/uploader/Uploader';
import { acceptedFileExtensions, photoConverters } from '../../vue/utils/photo-converters';
import ChooseFileHeader from './ChooseFileHeader';

export default {
	name: 'UploaderPage',
	data() {
		let destinationAlbumId = null;
		let embeddedTags = this.$route.query.embeddedTags;
		if(embeddedTags && typeof embeddedTags === 'string') {
			embeddedTags = embeddedTags.split(',');
			destinationAlbumId = embeddedTags[0].replace('destinationAlbum-', '');
		}

		return {
			albumId: this.$route.params.id || this.$route.query.album,
			albumName: this.$route.query.destinationName,
			schoolName: this.$route.query.school,
			tags: embeddedTags,
			acceptedFileExtensions,
			photoConverters,
			chooseFileHeaderComponent: ChooseFileHeader,
			extraStepProps: {
				destinationAlbumId,
				projectId: this.$route.query.projectId,
				changeEmbeddedTags: (newAlbum) => {
					this.tags = 'destinationAlbum-' + newAlbum.id;
					let startAlbumName = this.albumName;
					this.albumName = newAlbum.name;

					if(destinationAlbumId) {
						let newUrl = window.location.href
							.replace(`embeddedTags=destinationAlbum-${destinationAlbumId}`, `embeddedTags=destinationAlbum-${newAlbum.id}`)
							.replace(`destinationName=${encodeURIComponent(startAlbumName)}`, `destinationName=${encodeURIComponent(this.albumName)}`);
						destinationAlbumId = this.extraStepProps.destinationAlbumId = newAlbum.id;
						history.replaceState(null, null, newUrl);
						
					}
				}
			}
		};
	},
	computed: {
		subtitle() {
			return this.i18n('uploader.guest.subtitle', {
				schoolName: this.schoolName,
				albumName: this.albumName ?? ''
			});
		}
	},
	components: {
		Uploader
	}
}
</script>

<style scoped>
	.uploader-page {
		width: 100%;
		z-index: 1;
	}

	.app-logo {
		max-height: 20vh;
	}

	@media all and (orientation:portrait) {
		.app-logo {
			max-width: 90%;
		}
	}

	@media all and (orientation:landscape) {
		.app-logo {
			max-width: 40%;
		}
	}

	.uploader-page {
		margin-top: 1em;
	}
</style>